<template>
  <div class="login">
    <page-header />
    <page-prompt />
    <section class="main">
      <h2>区域赛登录</h2>
      <ul class="form">
        <li>
          <span>
            <el-input v-model="mobile" placeholder="请填写手机号码" />
          </span>
        </li>
        <li>
          <span>
            <el-input v-model="password" placeholder="请输入密码" show-password />
          </span>
        </li>
      </ul>
      <el-button class="submit" type="primary" @click="onLogin">点击验证登录</el-button>
      <div class="btns">
        <router-link to="/register">立即注册</router-link>
        <router-link to="/forgetpwd">忘记密码</router-link>
      </div>
      <p class="prompt">浏览器使用建议：请使用谷歌、火狐或IE10以上的浏览器。</p>
    </section>
    <div class="show-box" v-if="show">
      <div class="mask-box" @click="show=false"></div>
      <div class="txt-box">
        <p style="text-indent: 2em;">
          2025年“中包杯”中国大学生包装与食品工程创新创意大赛自4月启动以来，得到全国高校师生的积极响应。为充分响应广大师生诉求，合理利用大赛资源，并为参赛师生提供更充足的准备时间，经大赛执委会研究决定：
        </p>
        <p style="text-indent: 2em; color: red;">
          现延长大赛作品提交截止日期至2025年8月31日。
        </p>
        <label class="close" @click="show=false">关闭</label>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PagePrompt from '@/components/PagePrompt'
import { login } from '@/service/api'

export default {
  name: 'PageLogin',
  components: {
    PageHeader,
    PagePrompt
  },
  data () {
    return {
      show: false,
      mobile: '',
      password: ''
    }
  },
  methods: {
    onLogin () {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile))) {
        this.$alert('手机号码填写错误!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (!this.password) {
        this.$alert('请填写密码!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (this.password.length < 6) {
        this.$alert('密码不能小于6位!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      login({
        mobile: this.mobile,
        password: this.password
      }).then(res => {
        loading.close()
        this.$router.push('/basic')
      }).catch(err => {
        loading.close()
        this.$message({
          message: err,
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
